<template>
  <div class="contenedor">
    <b-card class="contenedor">
      <div slot="header">
        <strong>
          <center style="font-size:15pt;">Sga Completo</center>
        </strong>
      </div>

      <div v-if="selectedSgaCompletoEt.clasePeligro == ''">
        <h5>
          <center>ESTE PRODUCTO NO SE HA CLASIFICADO CON SGA</center>
        </h5>
      </div>

      <b-card align="left" v-else>
        <!--<b-row>
          <b-col sm="2" class="mb-2">
            <label class="mr-sm-2" for="inline-form-custom-select-pref">Version</label>
            <br />
          </b-col>
          <b-col sm="2" class="mb-2">
            <b-form-select
              v-model="version"
              :options="versiones"
              size="sm"
              class="form-control"
              @change="cambiaVersion"
            />
          </b-col>
          <b-col sm="2" class="mb-2 ml-2">
            <b-col sm="6"></b-col>
            <b-col sm="6">
              <b-button style="width:50px;" size="sm" variant="primary" @click="actualizarSgaCompleto"><i class="fa fa-refresh"></i> Actualizar</b-button>
            </b-col>
          </b-col>
        </b-row>-->
        <b-row style="background:#FF1525;color:#fff;padding:5px;padding:5px;vertical-align:middle;">
          <b-col sm="12">
            <h5>Pictogramas</h5>
          </b-col>
        </b-row>
        <b-row >
          <b-col sm="12">
            <b-row >
              <div
                v-for="(pictograma, index) in pictogramas_et.Homologacion"
                :key="index"
                style="height:140px"
              >
                <b-col v-if="pictograma.estado == 1">
                  <b-card
                    :img-src="pictograma.direccion"
                    img-alt="Image"
                    tag="article"
                    style="display:block;margin:auto;max-width: 115px; margin-top:5px; height:115px;border: 1px solid #ccc;"
                    class="mb-4"
                  ></b-card>
                </b-col>
              </div>
            </b-row>

          </b-col>
        </b-row>
        <b-row style="background:#FF1525;color:#fff;padding:5px;">
          <b-col sm="12">
            <h5>Clase de peligro</h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <p v-html="selectedSgaCompletoEt.clasePeligro"></p>
          </b-col>
        </b-row>
        <b-row style="background:#FF1525;color:#fff;padding:5px;">
          <b-col sm="12">
            <h5>Palabra de advertencia</h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <b v-html="selectedSgaCompletoEt.palabraSga"></b>
          </b-col>
        </b-row>
        <b-row style="background:#FF1525;color:#fff;padding:5px;">
          <b-col sm="12">
            <h5>Indicaciones de peligro</h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <p v-html="selectedSgaCompletoEt.indicaciones"></p>
          </b-col>
        </b-row>
        <b-row style="background:#FF1525;color:#fff;padding:5px;">
          <b-col sm="12">
            <h5>Generales</h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <ul style="list-style:none;margin:0;padding:0;">
              <li>
                <b>P101</b> Si se necesita consejo médico, tener a mano el envase o la etiqueta.
              </li>
              <li>
                <b>P102</b> Mantener fuera del alcance de los niños.
              </li>
              <li>
                <b>P103</b> Leer la etiqueta antes del uso.
              </li>
            </ul>
          </b-col>
        </b-row>
        <b-row style="background:#FF1525;color:#fff;padding:5px;">
          <b-col sm="12">
            <h5>Prevención</h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <p v-html="selectedSgaCompletoEt.prevencion"></p>
          </b-col>
        </b-row>
        <b-row style="background:#FF1525;color:#fff;padding:5px;">
          <b-col sm="12">
            <h5>Intervención</h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <p v-html="selectedSgaCompletoEt.intervencion"></p>
          </b-col>
        </b-row>
        <b-row style="background:#FF1525;color:#fff;padding:5px;">
          <b-col sm="12">
            <h5>Almacenamiento</h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <p v-html="selectedSgaCompletoEt.almacenamiento"></p>
          </b-col>
        </b-row>
        <b-row style="background:#FF1525;color:#fff;padding:5px;">
          <b-col sm="12">
            <h5>Eliminación</h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <p v-html="selectedSgaCompletoEt.eliminacion"></p>
          </b-col>
        </b-row>
      </b-card>
    </b-card>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import loader from "../../../../containers/loader";

export default {
  name: "SgaCompletoET",
  computed: {
    ...mapState("sgacompleto_et", ["selectedSgaCompletoEt", "version", "idioma"]),
    ...mapState("etiquetas", ["VisualEmpresa"]),
    ...mapState("sga_et", ["idiomas", "versiones", "pictogramas_et"])
  },
  methods: {
    actualizarSgaCompleto() {
      this.getSgaCompleto();
    },
    ...mapActions("sgacompleto_et", ["getSgaCompleto"]),
    ...mapActions("sga_et", ["getPictogramas"]),
    ...mapMutations("sgacompleto_et", ["cambiaIdioma", "cambiaVersion"])
  }
};
</script>
